import {
    Button,
    ControlledTextInput,
    LoadingSpinner,
    Modal,
    Typography,
} from '@analytical-alley/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const schema = z.object({
    name: z.string().min(1, 'Name is required'),
});

interface Props {
    showModal: boolean;
    isSaving?: boolean;
    onClose: () => void;
    onSave: (name: string) => void;
    defaultName?: string;
}

export const SaveAsCampaignDialog = ({
    showModal,
    onClose,
    onSave,
    isSaving = false,
    defaultName = '',
}: Props) => {
    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(schema),
        defaultValues: {
            name: defaultName,
        },
    });

    const onSubmit = (data: { name: string }) => {
        onSave(data.name);
    };

    return (
        <Modal dismissible show={showModal} onClose={onClose}>
            <Modal.Header>Create New Campaign</Modal.Header>
            <Modal.Body className="text-white flex flex-col gap-4">
                <LoadingSpinner show={isSaving} />
                <Typography variant="bodyM" className="mb-4 center">
                    Are you sure you want to create new campaign?
                </Typography>
                <form className="grid grid-cols-2 gap-4">
                    <div className="col-span-2">
                        <ControlledTextInput
                            label="Campaign Name"
                            name="name"
                            control={control}
                            errors={errors}
                        />
                    </div>
                </form>
            </Modal.Body>
            <Modal.Footer className="py-4">
                <Button
                    className="ml-2"
                    size="sm"
                    color="light"
                    onClick={handleSubmit(onSubmit)}
                >
                    Save
                </Button>
                <Button
                    className="ml-2"
                    size="sm"
                    color="red"
                    onClick={onClose}
                >
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
